import React from "react";
import { Link, useNavigate } from "react-router-dom";
const DynamicBackground = ({
    bgImageUrl,
    bgColor,
    title,
    subtitle,
    textColor,
    dynamicText
}) => {
    const userType = JSON.parse(sessionStorage.getItem("#roles") || "{}");
    const url = userType === "student"? "../my-courses":userType === "teacher"?"../my-training":""
    const navigate = useNavigate()
    return (
        <div
            className={`relative h-[225px] w-full bg-cover bg-center ${bgColor} flex rounded-lg p-6`}
            // style={{ backgroundColor: `${bgColor}` }}
        >
            {/* SVG Container */}
            <div className="absolute right-0 top-0 h-full flex flex-col gap-4">
                {/* SVG 1 */}
                <svg
                    className="w-[61px] h-[104px] opacity-30 absolute right-[12%]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 61 104"
                    fill="white"
                >
                    <path d="M30.5 0C30.5 0 32.1828 26.7797 38.7378 37.9553C45.2927 49.1309 61 52 61 52C61 52 45.2927 54.8691 38.7378 66.0447C32.1828 77.2203 30.5 104 30.5 104C30.5 104 28.8172 77.2203 22.2622 66.0447C15.7073 54.8691 0 52 0 52C0 52 15.7073 49.1309 22.2622 37.9553C28.8172 26.7797 30.5 0 30.5 0Z" />
                </svg>

                {/* SVG 2 */}
                <svg
                    className="w-[80px] h-[103px] opacity-30 absolute right-[11%] top-[53%]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 80 103"
                    fill="white"
                >
                    <path d="M40 0C40 0 42.207 41.7145 50.8036 59.1226C59.4003 76.5308 80 81 80 81C80 81 59.4003 85.4692 50.8036 102.877C42.207 120.286 40 162 40 162C40 162 37.793 120.286 29.1964 102.877C20.5997 85.4692 0 81 0 81C0 81 20.5997 76.5308 29.1964 59.1226C37.793 41.7145 40 0 40 0Z" />
                </svg>
                {/* SVG 3 */}
                <svg
                    className="w-[80px] h-[124px] opacity-30 absolute top-[15%] right-[70%]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 80 103"
                    fill="white"
                >
                    <path d="M40 0C40 0 42.207 41.7145 50.8036 59.1226C59.4003 76.5308 80 81 80 81C80 81 59.4003 85.4692 50.8036 102.877C42.207 120.286 40 162 40 162C40 162 37.793 120.286 29.1964 102.877C20.5997 85.4692 0 81 0 81C0 81 20.5997 76.5308 29.1964 59.1226C37.793 41.7145 40 0 40 0Z" />
                </svg>
                <svg
                    className="w-[61px] h-[103px] opacity-30"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 61 103"
                    fill="none"
                >
                    <path
                        d="M30.5 -59C30.5 -59 32.1828 -17.2855 38.7378 0.122646C45.2927 17.5308 61 22 61 22C61 22 45.2927 26.4692 38.7378 43.8774C32.1828 61.2855 30.5 103 30.5 103C30.5 103 28.8172 61.2855 22.2622 43.8774C15.7073 26.4692 0 22 0 22C0 22 15.7073 17.5308 22.2622 0.122646C28.8172 -17.2855 30.5 -59 30.5 -59Z"
                        fill="white"
                        fill-opacity="0.1"
                    />
                </svg>
                <svg
                    className="w-[80px] h-[124px] opacity-30 absolute right-[5%] top-[15%]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 80 124"
                    fill="none"
                >
                    <path
                        d="M40 0C40 0 42.207 31.9296 50.8036 45.2544C59.4003 58.5791 80 62 80 62C80 62 59.4003 65.4209 50.8036 78.7456C42.207 92.0704 40 124 40 124C40 124 37.793 92.0704 29.1964 78.7456C20.5997 65.4209 0 62 0 62C0 62 20.5997 58.5791 29.1964 45.2544C37.793 31.9296 40 0 40 0Z"
                        fill="white"
                        fill-opacity="0.1"
                    />
                </svg>
            </div>

            {/* Content */}
            <div
                className={`relative z-10 text-start flex flex-col gap-4 md:w-[40%] ${textColor}`}
                // style={{ color: `${textColor}` }}
            >
                <h1 className="text-[12px] leading-[18px] font-light">{title}</h1>
                <p className="text-2xl leading-[32px] font-semibold">{subtitle}</p>
                <Link to={url}  className={`border-none bg-white ${dynamicText} rounded-md w-fit py-[10px] px-[24px] font-semibold`}>
                    {userType === "student"? "Discover Courses":userType === "teacher"?"Explore Resources":"Discover Courses"}
                </Link>
            </div>
        </div>
    );
};

export default DynamicBackground;
